// removed by extract-text-webpack-plugin
module.exports = {"spin":"_3lH5TU32hYkGLbd7mxiB1g"};


//////////////////
// WEBPACK FOOTER
// ./src/styles.scss
// module id = 844
// module chunks = 18